define(["require", "exports", "./core/AxiosHttpRequest", "./services/PhoneNumberService"], function (require, exports, AxiosHttpRequest_1, PhoneNumberService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PhoneNumberClient = void 0;
    class PhoneNumberClient {
        constructor(openApiConfig, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
            var _a, _b, _c, _d;
            this.request = new HttpRequest({
                BASE: (_a = openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.BASE) !== null && _a !== void 0 ? _a : 'https://phonenumber-api.gll.ciptex.com',
                VERSION: (_b = openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.VERSION) !== null && _b !== void 0 ? _b : '1.0',
                WITH_CREDENTIALS: (_c = openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
                CREDENTIALS: (_d = openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.CREDENTIALS) !== null && _d !== void 0 ? _d : 'same-origin',
                TOKEN: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.TOKEN,
                USERNAME: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.USERNAME,
                PASSWORD: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.PASSWORD,
                HEADERS: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.HEADERS,
                ENCODE_PATH: openApiConfig === null || openApiConfig === void 0 ? void 0 : openApiConfig.ENCODE_PATH,
            });
            this.phonenumber = new PhoneNumberService_1.PhoneNumberService(this.request);
        }
    }
    exports.PhoneNumberClient = PhoneNumberClient;
});
